import buttonStyle from '../../../../materialUI/components/CustomButtons/buttonStyle'

const chargeOverrideStyle = {
  ...buttonStyle,
  buttonGrid: {
    marginTop: '20px',
  },
  componentPanel: {
    marginTop: '30px',
  },
  fieldSpacing: {
    marginTop: '10px',
  },
  leftHeading: {
    textAlign: 'left',
    marginTop: '20px',
    marginBottom: '20px',
  },
  inputFormContainer: {
    marginTop: '20px',
    marginLeft: '30px',
    width: '600px',
  },
  buttonsContainer: {
    marginLeft: '30px',
  },
  fromToLabel: {
    fontSize: 'var(--fs-13, 0.8125rem)',
    fontWeight: '600',
    marginTop: '20px',
  },
  labelColour: {
    color: 'rgba(0, 0, 0, 0.54)',
  },
  leftPadding: { paddingLeft: '10px' },
}

export default chargeOverrideStyle
